import { motion } from "framer-motion";
import { WHY_CHOOSE } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

export default function WhyChoose() {
  return (
    <section id="why-choose" className="py-24 lg:py-32 bg-white" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-2xl mb-12">
          <Reveal>
            <div className="text-[11.5px] uppercase tracking-[0.22em] text-medis-teal font-semibold">Why Choose MEDIS Group LLP</div>
            <h2 className="mt-3 font-display font-bold text-medis-navy text-3xl sm:text-4xl lg:text-[40px] leading-[1.1] tracking-tight">
              Six reasons hospitals and diagnostic centres partner with us.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_CHOOSE.map((r, i) => (
            <motion.div
              key={r.num}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: Math.min(i * 0.07, 0.35) }}
              className="group relative rounded-xl border border-medis-silver/30 bg-white p-7 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              data-testid={`why-card-${r.num}`}
            >
              <div className="absolute top-0 left-0 h-[3px] w-0 group-hover:w-full rounded-full bg-medis-teal transition-all duration-500" />
              <div className="font-display font-bold text-[34px] leading-none text-medis-silver/40 group-hover:text-medis-blue transition-colors duration-300">
                {r.num}
              </div>
              <h3 className="relative mt-4 font-display font-semibold text-medis-navy text-[17px] leading-snug">{r.title}</h3>
              <p className="relative mt-2.5 text-[13.5px] text-medis-gray leading-relaxed">{r.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
